import React from 'react';
import { Helmet } from 'react-helmet-async';

interface JsonLdProps {
  data: object | object[];
}

/** Injects JSON-LD structured data for SEO and agentic discoverability */
export const JsonLd: React.FC<JsonLdProps> = ({ data }) => {
  const json = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {json.map((item, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </Helmet>
  );
};
